// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2196262d","160":"a115cd71","208":"795e8a7a","293":"4cbf9f72","516":"4a89de72","519":"58fb7728","917":"9a0af4e5","946":"137fe03a"}[chunkId] + ".chunk.js";
};